import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 订单列表
     */
    orders: function orders() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/order/orders',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 订单详情
     * @param {Object} data
     */
    orderDetails: function orderDetails() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/orderDetails',
        data: data
      });
    },

    /**
     * @description 修改备注
     * @param {Object} data
     */
    remark: function remark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/remark',
        data: data
      });
    },

    /**
     * @description 订单数量
     * @param {Object} data
     */
    orderCount: function orderCount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/orderCount',
        data: data
      });
    },

    /**
     * @description 更新收货地址
     * @param {Object} data
     */
    updateConsignee: function updateConsignee() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/updateConsignee',
        data: data
      });
    },

    /**
     * @description 在订单详情里面修改出库地址
     * @param {Object} data
     */
    updateDeliveryAddress: function updateDeliveryAddress() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/updateDeliveryAddress',
        data: data
      });
    },
    // 

    /**
     * @description 在售后服务单发出新货详情里面修改出库地址
     * @param {Object} data
     */
    updateDeliveryAddressSale: function updateDeliveryAddressSale() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/updateDeliveryAddress',
        data: data
      });
    },

    /**
     * @description 修改运费
     * @param {Object} data
     */
    updateDeliveryAmount: function updateDeliveryAmount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/updateDeliveryAmount',
        data: data
      });
    },

    /**
     * @description 出库
     * @param {Object} data
     */
    delivery: function delivery() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/delivery',
        data: data
      });
    },

    /**
     * @description 延迟出库提醒
     * @param {Object} data
     */
    overdueDelivery: function overdueDelivery() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/overdueDelivery',
        data: data
      });
    },

    /**
     * @description 延迟出库记录
     * @param {Object} data
     */
    overdueDeliveryList: function overdueDeliveryList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/overdueDeliveryList',
        data: data
      });
    },

    /**
     * @description 出库记录
     * @param {Object} data
     */
    deliveryList: function deliveryList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/deliveryList',
        data: data
      });
    },

    /**
     * @description 取消订单列表
     * @param {Object} data
     */
    cancelList: function cancelList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/cancelList',
        data: data
      });
    },

    /**
     * @description 取消订单详情
     * @param {Object} data
     */
    cancelDetails: function cancelDetails() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/cancelDetails',
        data: data
      });
    },

    /**
     * @description 设置自动审核
     * @param {Object} data
     */
    setAutoAudit: function setAutoAudit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/setAutoAudit',
        data: data
      });
    },

    /**
     * @description 数量
     * @param {Object} data
     */
    cancelCount: function cancelCount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/cancelCount',
        data: data
      });
    },

    /**
     * @description 审核取消订单
     * @param {Object} data
     */
    audit: function audit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/audit',
        data: data
      });
    },

    /**
     * @description 获取自动审核
     * @param {Object} data
     */
    getAutoAudit: function getAutoAudit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/cancel/getAutoAudit',
        data: data
      });
    },

    /**
    * @description 订单导出
    * @param {Object} data
    */
    exportOrders: function exportOrders() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/order/exportOrders',
        data: data
      });
    },

    /**
    * @description 日月账单导出
    * @param {Object} data
    */
    exportBills: function exportBills() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/exportBills',
        data: data
      });
    }
  };
});